<template>
  
<FormKitLazyProvider>
<FormKit
    :id="option.option_id"
    :name="option.option_id"
    type="text"
    :label="`${optionLabel}`"
    :help="$t('Maximum amount of characters', { count: option.fieldValue.max_characters })"
    :value="value"
    :validation="`required|length:0,${option.fieldValue.max_characters}`"
    :validation-messages="{
      length: $t('Maximum amount of characters', { count: option.fieldValue.max_characters }),
      required: $t('This is a required field.'),
    }"
  />
</FormKitLazyProvider>

</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const { option } = defineProps({
  option: {
    type: Object,
    required: true,
  },
  value: {
    type: String,
    default: '',
  },
})

const optionLabel = computed<string>(() =>
  option.title?.split('|')?.[0] || option.title,
)
</script>
